<template>
  <div
    class="article-track"
    :class="{ dark }"
    @click="click">
    <span
      class="article-track-number"
      :class="{ playing: current }">
      <span
        v-if="!current">
        {{ track }}
      </span>
      <FlatIcon
        v-else
        :name="icon"
        :size="24" />
    </span>
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ArticleTrack',
  props: {
    marker: {
      type: Object,
      required: true
    },
    playlist: {
      type: Array
    },
    track: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      highlight: 'global/highlight',
      markerSpeech: 'speech/markerSpeech',
      currentIndex: 'speech/currentIndex',
      paused: 'speech/paused',
      reading: 'speech/reading'
    }),
    index () {
      return this.track - 1
    },
    current () {
      return this.markerSpeech && this.marker._id === this.markerSpeech._id && this.currentIndex === this.index
    },
    icon () {
      if (this.current && this.paused) return 'play-white'
      return 'pause-white'
    }
  },
  methods: {
    ...mapActions({
      startMarkerPlaylist: 'speech/startMarkerPlaylist',
      playTrackByIndex: 'speech/playTrackByIndex',
      pause: 'speech/pause',
      resume: 'speech/resume'
    }),
    click () {
      if (this.markerSpeech && this.markerSpeech._id === this.marker._id) {
        if (this.currentIndex === this.index) {
          if (this.paused) this.resume()
          else this.pause()
        } else {
          this.playTrackByIndex(this.index)
        }
      } else {
        this.startMarkerPlaylist({
          marker: this.marker,
          playlist: this.playlist,
          i: this.index
        })
      }
    }
  }
}
</script>

<style lang="scss">
.article-track {
  display: block;
  position: relative;
  margin: 16px 0;
  p {
    margin: 0;
  }
}
.article-track-number {
  display: block;
  position: relative;
  float: left;
  margin-right: 10px;
  margin-top: 4px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px 0px, rgba(0, 0, 0, 0.24) 0px 1px 2px 0px;
  border-radius: 5px;
  padding: 0 6px;
  box-sizing: border-box;
  transition: all .2s ease-in-out;
  &.playing {
    background: var(--f7-theme-color);
    color: white;
    box-shadow: none;
    border-radius: 20px;
  }
  .flat-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}
.dark {
  .article-track-number {
    background: #222;
    &.playing {
      background: var(--f7-theme-color);
    }
  }
}
</style>
